import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const ROVO_INLINE_INPUT_BOX_CLIENT_ID: ClientId = client('rovo-inline-input-box');
